// Find the name of the OSM road edge nearest to a point. The road network is
// already loaded from OSM (backend get_road_network / assign-trips set each
// edge's `name` from OSMnx), so gate road names come from the SAME source as the
// rest of the app — no external geocoder needed. Returns '' if nothing is near
// or the nearest road is unnamed.

// Squared distance from point (px,py) to segment (a→b), in a locally-planar
// metric where longitude is scaled by cos(lat) so degrees compare fairly.
function distToSeg2(px, py, ax, ay, bx, by, cos) {
  const AX = (ax - px) * cos, AY = ay - py;
  const BX = (bx - px) * cos, BY = by - py;
  const dx = BX - AX, dy = BY - AY;
  const len2 = dx * dx + dy * dy;
  let t = len2 ? -(AX * dx + AY * dy) / len2 : 0;
  t = Math.max(0, Math.min(1, t));
  const cx = AX + t * dx, cy = AY + t * dy;
  return cx * cx + cy * cy;
}

export function nearestEdgeName(lng, lat, edges) {
  const feats = edges && edges.features;
  if (!feats || !feats.length) return '';
  const cos = Math.cos(lat * Math.PI / 180) || 1;
  let best = Infinity, bestName = '';
  for (const f of feats) {
    const g = f.geometry;
    if (!g) continue;
    const lines = g.type === 'LineString' ? [g.coordinates]
      : g.type === 'MultiLineString' ? g.coordinates : [];
    const name = (f.properties && f.properties.name) || '';
    for (const line of lines) {
      for (let i = 0; i < line.length - 1; i++) {
        const a = line[i], b = line[i + 1];
        const d = distToSeg2(lng, lat, a[0], a[1], b[0], b[1], cos);
        if (d < best) { best = d; bestName = name; }
      }
    }
  }
  return bestName || '';
}
